<aside>
  <div id="sidebar" class="nav-collapse ">
    <div class="logo-wrapper">
      <a href="index.html" class="logo colored"><img src="/assets/ReportsFeed_Inverse_Logo_Colored.png"></a>
    </div>
    <div class="welcome-text">
      <span class="welcome-label" i18n="menu prefix greeting|Text before the username at the menu@@welcomeLabel">Welcome,</span>
      <a title="My account" class="account-link" routerLink="/account">{{ username }}</a>
      <a type="button" role="button" title="Logout" class="logout-link" (click)="logoutClick()"><i class="fa fa-sign-out" aria-hidden="true"></i></a>
    </div>
    <ul class="sidebar-menu" id="nav-accordion">
      <li *ngFor="let menuItem of navItens" [ngClass]="menuItem.page==null || menuItem.children?'sub-menu dcjq-parent-li':''">
        <ng-container *ngIf="shouldShowNavItem(menuItem)">
          <a *ngIf="menuItem.page != null" [ngClass]="router.url.trim().substr(1) == menuItem.page ? 'active':''" [routerLink]="['/'+menuItem.page]">
            <i *ngIf="menuItem.fa_icon != ''" class="fa" [ngClass]="menuItem.fa_icon"></i>
            <span>{{ interpretName(menuItem.name) }}</span>
          </a>
          <a *ngIf="menuItem.page == null" href="javascript:;" (click)="showSub(menuItem)">
            <i *ngIf="menuItem.fa_icon != ''" class="fa" [ngClass]="menuItem.fa_icon"></i>
            <span>{{ interpretName(menuItem.name) }}</span>
          </a>
          <ul [hidden]="!menuItem.children || (isChildrenActive(menuItem) && menuItem.hide_children === true)" class="sub">
            <li *ngFor="let sub of menuItem.children" [ngClass]="router.url.trim().substr(1)==sub.page?'active':''">
              <a [routerLink]="['/'+sub.page]" >
                <i *ngIf="sub.fa_icon != ''" class="fa" [ngClass]="sub.fa_icon"></i>
                <span>{{ interpretName(sub.name) }}</span>
              </a>
            </li>
          </ul>
        </ng-container>
      </li>
    </ul>
  </div>
</aside>
